// external modules
import { useTranslation } from "react-i18next";
// components
import SubTitle from "../@common/SubTitle/SubTitle";
import Title from "../@common/Title/Title";
import ImageRenderer from "components/@common/ImageRenderer/ImageRenderer";

// styles & types & assets
import community from "assets/img/@intro/community.webp";
import styles from "./Step4.module.scss";

export default function Step4() {
  const { t } = useTranslation();
  return (
    <section className={styles["wrapper-step4"]}>
      <div className={styles["wrap-title"]}>
        <SubTitle>{t("1,000만 탈모인들의 고민 상담소")}</SubTitle>
        <Title>{t("전문적인 탈모 커뮤니티")}</Title>
      </div>
      <div className={styles["wrap-community"]}>
        <ImageRenderer src={community} alt={"community"} />
      </div>
    </section>
  );
}
